import React, { useState, useEffect } from "react";
import Api from "Api/Api";
import { Modal, Button } from "antd";
import { AntSelect, AntInput, AntDate } from "components/AntComponents"
import { Formik } from 'formik';

export default function StartupInvestmentDetails({ id, onClose, investorId, readonly = false }) {
  const INITIAL_FORM_VALUE = {
    investment_type: null,
    ccd_floor: null,
    ccd_cap: null,
    ccd_discount: null,
    valuation_for_last_valued_round: null,
    date_of_investment: null,
    no_of_share: null,
    investment_price_per_share: null,
    current_price_per_share: null,
    investor: null,
    amount: null,
    selectedInvestor: null
  };

  const INVESTMENT_TYPES = [
    "Equity",
    "CCD",
    "CCPS",
    "Safe Notes",
    "Token/USSD",
  ];

  const CURRENCY_TYPES = ["INR", "USD"];

  const [startup_id, setStartup_id] = useState(null);
  const [details, setDetails] = useState(INITIAL_FORM_VALUE);
  const [showPopup, setShowPopup] = useState(false);
  const [investors, setInvestors] = useState([]);
  const [selectedInvestor, setSelectedInvestor] = useState(null);

  const closePopup = () => {
    setDetails(INITIAL_FORM_VALUE);
    setStartup_id(null);
    setShowPopup(false);
    onClose();
  };

  const saveData = async () => {
    let data = details;
    data.startup = startup_id;
    data.investor = selectedInvestor;
    const response = await Api.updateStartupInvestmentDetail(
      startup_id,
      selectedInvestor,
      details
    );
    if (response) {
      if (response.status === 200) {
        closePopup();
      }
    }
  };

  const valueChanged = (e) => {
    setDetails({ ...details, [e.element.id]: e.value });
    if (e.element.id === "investor") {
      setSelectedInvestor(e.value);
      loadData(e.value);
    }
  };

  const loadData = async (investor = null) => {
    setStartup_id(id);
    const response = await Api.getStartupInvestmentDetail(id, investor);
    if (response) {
      if (response.status === 200) {
        if (response.data.length) {
          setDetails(response.data[0]);
        } else {
          setDetails(INITIAL_FORM_VALUE);
        }
      }
    }
  };

  const getInvestorsData = async (startupId) => {
    const investorResponse = await Api.getInvestorsDataFromStartupID(
      startupId,
      "investor"
    );
    if (investorResponse.status === 200) {
      const investors = investorResponse.data.map((record) => record.investor);
      setInvestors(investors);
      const selectedInvestorId = investorId || investors[0].id;
      setSelectedInvestor(selectedInvestorId);
      loadData(selectedInvestorId);
    }
  };

  useEffect(() => {
    if (id) {
      if (!investorId) {
        getInvestorsData(id);
      } else {
        setSelectedInvestor(investorId);
        loadData(investorId);
      }
      setShowPopup(true);
    }
  }, [id]);

  return (
    <Modal title="Investment details" open={showPopup} onCancel={closePopup} footer={null}>
      <div>
        {
          readonly && <>
            {details.id && Object.entries(details).map(([key, value]) => {
              return <div className="grid grid-cols-2">
                <span><b className="capitalize">{key.replace(/_/g, " ")}</b></span>
                <span>{value || 'NIL'}</span>
              </div>
            }
            )}
            {!details.id && <div>No data available</div>}
          </>
        }
        {
          !readonly && <Formik
            initialValues={INITIAL_FORM_VALUE}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
            }}
          >
            {({
              values,
              errors,
              handleSubmit,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <AntSelect
                  options={{
                    allowClear: true
                  }}
                  value={values.investor}
                  dataSource={investors}
                  displayExpr={"username"}
                  valueExpr={"id"}
                  setFieldValue={setFieldValue}
                  fieldName="investor"
                  errors={errors}
                />
                <AntSelect
                  options={{
                    allowClear: true
                  }}
                  value={values.investment_type}
                  dataSource={INVESTMENT_TYPES}
                  setFieldValue={setFieldValue}
                  fieldName="investment_type"
                />
                <AntSelect
                  options={{
                    allowClear: true
                  }}
                  value={values.currency}
                  dataSource={CURRENCY_TYPES}
                  setFieldValue={setFieldValue}
                  fieldName="currency"
                  errors={errors}
                />
                {values.investment_type === "CCD" && <AntInput
                  value={values.ccd_cap}
                  setFieldValue={setFieldValue}
                  fieldName={"ccd_cap"}
                  errors={errors}
                  options={{
                    placeholder: "CCD Cap"
                  }}
                />}

                <AntInput
                  value={values.valuation_for_last_valued_round}
                  setFieldValue={setFieldValue}
                  fieldName={"valuation_for_last_valued_round"}
                  errors={errors}
                />
                <AntDate
                  fieldName={"date_of_investment"}
                  options={{
                    format: "YYYY-MM-DD"
                  }}
                  setFieldValue={setFieldValue}
                />
                <AntInput
                  value={values.no_of_share}
                  setFieldValue={setFieldValue}
                  fieldName={"no_of_share"}
                  errors={errors}
                />
                {values.investment_type === "CCD" && <AntInput
                  value={values.ccd_floor}
                  setFieldValue={setFieldValue}
                  fieldName={"ccd_floor"}
                  errors={errors}
                />}

                <AntInput
                  value={values.ccd_discount}
                  setFieldValue={setFieldValue}
                  fieldName={"ccd_discount"}
                  errors={errors}
                />
                <AntInput
                  value={values.investment_price_per_share}
                  setFieldValue={setFieldValue}
                  fieldName={"investment_price_per_share"}
                  errors={errors}
                />
                <AntInput
                  value={values.current_price_per_share}
                  setFieldValue={setFieldValue}
                  fieldName={"current_price_per_share"}
                  errors={errors}
                />
                <AntInput
                  value={values.amount}
                  setFieldValue={setFieldValue}
                  fieldName={"amount"}
                  errors={errors}
                />
                <Button type="primary" htmlType="submit">Save</Button>
              </form>
            )}
          </Formik>
        }
      </div>
    </Modal >
  );
}
